import get from './get';
import post from './post';
import query from './query';

export type PostPayload = {
  basePath: string;
  coreId: number;
  name: string;
  theme: object;
};

export default { get, post, query };
